import React,{ Component } from "react";
import { connect } from "react-redux";
import { get_saml_configs, deleteSaml, set_saml_config, update_saml_config } from "../../actions/actionSaml";
import { Link } from "react-router-dom";
import ReactTable from "react-table";
import { Row,Form, Col, FormGroup, InputGroup, Button, Modal, ModalHeader, ModalBody, ModalFooter, UncontrolledTooltip, Card, CardBody, CardHeader, Label, Input } from "reactstrap";
import { NotificationManager } from "react-notifications";
import LoadingSpinner from "../../components/LoadingSpinner/index";
import "react-table/react-table.css";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../components/Breadcrumb/BreadCrumbCompo";
import {deleteLdap} from "../../actions/actionLdap";
import { fuzzySearch } from "../../utils/helpers";


const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Saml",path:"/saml",isActive: true},
    {name: "Update Saml",path:"/updatesaml",isActive: true},
];


class Saml extends Component{
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            samlId: null
        };

        this.deleteConfirm = this.deleteConfirm.bind(this);
        this.cancelDelete = this.cancelDelete.bind(this);
        this.createSaml = this.createSaml.bind(this);
        this.deleteSamlAction = this.deleteSamlAction.bind(this);
        this.handleDeleteSuccess = this.handleDeleteSuccess.bind(this);
        this.handleDeleteError = this.handleDeleteError.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleAddSuccess = this.handleAddSuccess.bind(this);
        this.handleAddError = this.handleAddError.bind(this);
        this.addConfig = this.addConfig.bind(this);
    }

    componentDidMount() {
        this.props.getConfigs();
    }

    addConfig(){
        let formData = {};
        formData.display_name = " ";
        this.props.set_saml(formData)
            .then(() => {
                this.createSaml();
            })
            .catch(() => {
                this.handleAddError()
            });
    }

    createSaml(){
        const {SamlErrorMessage, saml_set} = this.props;
        let formData = {};
        if(SamlErrorMessage) {
            NotificationManager.error(SamlErrorMessage,"Failed to Add Saml Configuration", 3000);
        }else {
            formData.saml_id = saml_set.saml_id;
            formData.sp_acs_url = "https://" + window.location.host + "/api/acs/?id=" + saml_set.saml_id;
            formData.sp_slo_url = "https://" + window.location.host + "/api/slo/?id=" + saml_set.saml_id;
            formData.sp_entity_id = "https://" + window.location.host + "/api/metadata/?id=" + saml_set.saml_id;
            this.props.update_saml(formData)
                .then(() => {
                    this.handleAddSuccess();
                })
                .catch(() => {
                    this.handleAddError()
                });
        }
    }

    handleAddSuccess(){
        const {SamlErrorMessage, saml_set} = this.props;
        if(SamlErrorMessage) {
            NotificationManager.error(SamlErrorMessage,"Failed to Add Saml Configuration", 3000);
        }else{
            NotificationManager.success("Saml Added Successfully","Add Saml", 3000);
            this.setState({addModal: false});
            window.location.href = "/#/updatesaml/" + saml_set.saml_id;
        }
    }

    handleAddError(){
        const {SamlError} = this.props;
        if(SamlError){
            NotificationManager.error(SamlError,"Failed to Add Saml Configuration", 3000);
            this.props.history.push("/saml");
        }else{
            NotificationManager.error("Failed to Add Saml","Add Saml", 3000);
            this.props.history.push("/saml");
        }
    }

    deleteConfirm(samlId){
        this.setState({modal: !this.state.modal,
            samlId: samlId});
    }

    cancelDelete(){
        this.setState({modal: !this.state.modal});
    }

    deleteSamlAction(){
        this.props.deleteSaml(this.state.samlId).
        then(() => this.handleDeleteSuccess()).
        catch(() => this.handleDeleteError());
    }

    handleDeleteSuccess(){
        const {deleteSamlErrorMessage} = this.props;
        if(deleteSamlErrorMessage) {
            NotificationManager.error(deleteSamlErrorMessage,"Failed to Delete Saml", 3000);
        }else{
            NotificationManager.success("Saml Deleted Successfully","Delete Saml", 3000);
            this.setState({modal: false});
            this.props.getConfigs();
        }
    }

    handleDeleteError(){
        const {deleteSamlError} = this.props;
        if(deleteSamlError){
            NotificationManager.error(deleteSamlError,"Failed to Delete Saml", 3000);
            this.props.history.push("/saml");
        }else{
            NotificationManager.error("Failed to Delete Saml","Delete Saml", 3000);
            this.props.history.push("/saml");
        }
    }

    async handleChange(e) {
        const { target } = e;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const { name } = target;
        await this.setState({
            [name]: value,
        });
    }


    render(){
        if (this.props.samlConfigLoading){
            return (<div> <LoadingSpinner /></div>);
        }
        const { saml_configs } = this.props;
        const columns = [
            {
                Header: "Display Name",
                accessor: "display_name",
                filterMethod: fuzzySearch
            },
            {
                Header: "Enabled",
                accessor: "enabled",
                filterMethod: fuzzySearch,
                Cell: props => <span>{props.value ? "True" : "False"}</span>
            },
            {
                Header: "Auto Login",
                accessor: "auto_login",
                filterMethod: fuzzySearch,
                Cell: props => <span>{props.value ? "True" : "False"}</span>
            },
            {
                Header: "Actions",
                filterable: false,
                sortable: false,
                Cell: (data) => (<div className="action-btn">
                        <Link
                            className="btn btn-warning"
                            id={"Tooltipss"}
                            to={{ pathname: `/updatesaml/${data.original.saml_id}` }}>
                            <i className="fa fa-pencil"></i>
                        </Link>
                        <button
                            className="btn btn-danger"
                            id={"Tooltips"} href="#"
                            onClick={() => this.deleteConfirm(data.original.saml_id)}>
                            <i className="fa fa-trash-o"></i>
                        </button>
                    </div>
                ),
            }];
        return (
            <div>
                <BreadCrumbCompo routes={routes}/>
                <Row>
                    <Col sm={{ size: 10, order: 3, offset: 1 }}>
                        <Card >
                            <CardHeader>
                                <i className="fa fa-align-justify"></i> <strong>Saml Configurations</strong>
                                    <Button
                                        className="pull-right"
                                        onClick={this.addConfig}
                                        size="sm"
                                        color="dark">
                                        Create New Configuration
                                    </Button>
                            </CardHeader>
                            <CardBody>
                                <ReactTable
                                    columns={columns}
                                    data={saml_configs}
                                    loading={false}
                                    filterable
                                    defaultPageSize={10}
                                    className="-striped -highlight site_table"
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Modal isOpen={this.state.modal} toggle={this.cancelDelete} className={this.props.className}>
                    <ModalHeader toggle={this.cancelDelete}>Delete Configuration <i className="fa fa-bomb" aria-hidden="true"></i>
                    </ModalHeader>
                    <ModalBody>
                        Confirm Delete SAML Configuration?
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={this.deleteSamlAction} size="sm" color="danger"> <i className="fa fa-trash"></i> Delete</Button>
                        <Button onClick={this.cancelDelete} size="sm" color="basic"><i className="fa fa-ban"></i> Close</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

Saml.propTypes = {

};


export default connect(state =>
        ({
            saml_configs: state.saml.saml_configs || [],
            deleteSamlErrorMessage: state.saml.deleteSamlErrorMessage || null,
            deleteSamlLoading: state.saml.deleteSamlLoading || false,
            deleteSamlError: state.saml.deleteSamlError || null,
            SamlErrorMessage: state.saml.SamlErrorMessage || null,
            saml_set: state.saml.saml_set || null,
            SamlError: state.saml.SamlError || null,
            samlConfigLoading: state.saml.samlConfigLoading || null,
        }),
    dispatch =>
        ({
            getConfigs: () => dispatch(get_saml_configs()),
            deleteSaml: (data) => dispatch(deleteSaml(data)),
            set_saml: (formData) => dispatch(set_saml_config(formData)),
            update_saml: (formData) => dispatch(update_saml_config(formData)),
        }))(Saml);


// WEBPACK FOOTER //
// ./src/views/Saml/Saml.js